import { render } from "./HiddenChatWindow.vue?vue&type=template&id=c95c1996&scoped=true"
import script from "./HiddenChatWindow.vue?vue&type=script&lang=js"
export * from "./HiddenChatWindow.vue?vue&type=script&lang=js"

import "./HiddenChatWindow.vue?vue&type=style&index=0&id=c95c1996&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95c1996"]])

export default __exports__